export enum ENABLE_EDITING_VARIANTS {
  currentVersion = 'currentVersion',
  privateDraft = 'privateDraft',
  cancel = 'cancel',
}
